import React from 'react';
import { SalesProvider } from './SalesProvider';
import { SalesView } from './SalesView';

/**
 * Sales page container. Mounts the `SalesProvider` so every Sales
 * widget can read the shared filter state via `useSales()`. The page's
 * actual layout lives in `SalesView` so it stays render-only.
 */
export const Sales: React.FC = () => (
    <SalesProvider>
        <SalesView />
    </SalesProvider>
);
